import { render, staticRenderFns } from "./montageImg.vue?vue&type=template&id=4b832293&scoped=true"
import script from "./montageImg.vue?vue&type=script&lang=js"
export * from "./montageImg.vue?vue&type=script&lang=js"
import style0 from "./montageImg.vue?vue&type=style&index=0&id=4b832293&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b832293",
  null
  
)

export default component.exports